import {
  getCheckoutSessionsByCriteria,
  getCreditCardsByCriteria,
  getLoansByCriteria,
  getMerchants,
} from '@nemuru-eng/js-api-client';

import { FilterByType } from '@/components/shared/components/SuperSearchBar/types/FilterByType';
import { SearchResult } from '@/components/shared/components/SuperSearchBar/types/SearchResult';

export const getSearchResultsBySearchParams = async (
  queryString: string,
  filterByType: FilterByType,
  pageSize: number,
) => {
  if (filterByType === FilterByType.APPLICATIONS) {
    // FIXME: Pagination doesn't work correctly, we need to have a common criteria request for that

    const [loanList, cardsList] = await Promise.allSettled([
      getLoansByCriteria({ query: queryString }),
      getCreditCardsByCriteria({ query: queryString }),
    ]);

    let searchResults: SearchResult[] = [];
    let itemCount = 0;

    if (loanList.status === 'fulfilled' && loanList.value?.data) {
      searchResults = [...searchResults, ...loanList.value.data];
      itemCount += loanList.value.itemCount;
    }

    if (cardsList.status === 'fulfilled' && cardsList.value?.data) {
      searchResults = [...searchResults, ...cardsList.value.data];
      itemCount += cardsList.value.itemCount;
    }

    searchResults = searchResults
      .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
      .slice(0, pageSize);

    if (loanList || cardsList) {
      return {
        searchResults,
        itemCount,
      };
    }
  }

  if (filterByType === FilterByType.MERCHANTS) {
    const merchantsList = await getMerchants({ query: queryString });

    if (merchantsList) {
      return {
        searchResults: merchantsList?.data,
        itemCount: merchantsList.itemCount,
      };
    }
  }

  if (filterByType === FilterByType.CHECKOUT_SESSIONS) {
    const checkoutSessionsList = await getCheckoutSessionsByCriteria({ query: queryString });

    if (checkoutSessionsList) {
      return {
        searchResults: checkoutSessionsList?.data,
        itemCount: checkoutSessionsList.itemCount,
      };
    }
  }

  return {
    searchResults: null,
    itemCount: null,
  };
};
